import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./barGraphSkeleton.css"; // Custom styles

const BarGraphSkeleton = ({ bars = 6 }) => {
  // Generate random bar heights
  const barHeights = Array.from({ length: bars }).map(
    () => `${Math.floor(Math.random() * 40) + 60}%` // 60% to 100% height
  );

  return (
    <>
     <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ maxWidth: "20em"}}
        />
      <div
        style={{
          display:"flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "space-between",
          marginBottom:"2rem"
        }}
      >
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "4rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "4rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "4rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "4rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "4rem" }}
        />
      </div>
      <div className="bar-graph-skeleton-custom">
        {barHeights.map((height, index) => (
          <div
            key={index}
            className="barSkeleton-custom"
            style={{ height }}
          ></div>
        ))}
      </div>
      <div
        style={{
          display:"flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "space-between",
          marginBottom:"2rem"
        }}
      >
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "5rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "5rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "5rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "5rem" }}
        />
        <div
          className="baseSkeleton nudges-skeleton-text"
          style={{ minWidth: "5rem" }}
        />
      </div>
    </>
  );
};

export default BarGraphSkeleton;
